var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Pricing Management"}},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"List Price"}},[_c('list-price')],1),_c('vs-tab',{attrs:{"label":"Discount"}},[_c('div',{staticClass:"tab-text"},[_c('discount')],1)]),_c('vs-tab',{attrs:{"label":"Pricing Rule"}},[_c('div',{staticClass:"tab-text"},[_c('list-price-rule')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }